import moment from 'moment-timezone';

export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export const utcToTimezone = (date, timezone = defaultTimezone) => {
    return moment.utc(date).tz(timezone);
};

export const timezoneToUtc = (date, timezone = defaultTimezone) => {
    return moment.tz(date, timezone).utc();
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
    return utcToTimezone(date).format(format);
};

/**
 * Tournaments are anchored to the US Eastern calendar (where the audience is):
 * the backend takes the local Eastern day boundaries and serializes them as UTC.
 * Formatting those instants in UTC — or in the viewer's timezone — pushes the
 * end of the period into the next day (August 1 to Aug 31 renders as "Sep 1").
 * Always render tournament ranges in the tournament's own timezone.
 */
export const olympiadTimezone = 'America/New_York';

export const formatOlympiadDate = (date, format = 'YYYY-MM-DD') => {
    return utcToTimezone(date, olympiadTimezone).format(format);
};
